import { ConnectionHealthCadenceCard } from './ConnectionHealthCadenceCard'
import { ConnectionHealthStatusCard } from './ConnectionHealthStatusCard'

/**
 * Settings → Connection Health tab (Design §9): the org-wide check-interval
 * control plus the live per-gateway health surface. Lives as a Settings tab
 * rather than a standalone page.
 */
export function ConnectionHealthTab() {
  return (
    <div className="flex flex-col gap-card">
      <ConnectionHealthCadenceCard />
      <ConnectionHealthStatusCard />
    </div>
  )
}
